import PouchDB from 'pouchdb'
import Upsert from 'pouchdb-upsert'
import Erase from 'pouchdb-erase'
import Find from 'pouchdb-find'
import UpsertBulk from 'pouchdb-upsert-bulk'
import MemoryAdaptor from 'pouchdb-adapter-memory'
import HoodieAPI from 'pouchdb-hoodie-api'

import {getID, merge, isEqual} from 'webmango-utils'

export default function (defaults = {}) {
  return DB(PouchDB.defaults(defaults))
}

function DB (PouchDB) {
  PouchDB
    .plugin(Upsert)
    .plugin(Erase)
    .plugin(Find)
    .plugin(UpsertBulk)
    .plugin(MemoryAdaptor)
    .plugin(HoodieAPI)

  /**
   * Custom Plugins.
   * Convenience Helpers.
   */

  PouchDB.plugin({
    getID,
    async replace (key, newValue) {
      await this.upsert(key, oldValue => {
        if (newValue._deleted) return newValue
        if (oldValue._deleted) return false
        if (this.isEqual(newValue, oldValue)) return false
        return newValue
      })
      return this.getIfExists(key)
    },

    getIfExists (key) {
      return this.get(key).catch(err => {
        if (err.status === 404) return
        throw err
      })
    },

    async merge (key, newValue) {
      await this.upsert(key, oldValue => {
        if (newValue._deleted) return newValue
        if (oldValue._deleted) return false
        const merged = merge({}, oldValue, newValue)
        if (this.isEqual(merged, oldValue)) return false
        return merged
      })
      return this.getIfExists(key)
    },

    delete (key) {
      return this.replace(key, { _deleted: true })
    },

    async findAndDelete (query = {}) {
      const items = await this.findDocs(query)
      return this.bulkDocs(
        items.map(i => Object.assign(i, { _deleted: true }))
      )
    },

    isEqual (a, b) {
      return isEqual(a, b)
    },

    indexFields (...fields) {
      return this.createIndex({
        index: { fields }
      })
    },

    async findOne (query = {}) {
      const { docs } = await this.find(
        Object.assign({ limit: 1 }, query)
      )
      return docs[0]
    },

    async findDocs (options = {}) {
      const { docs } = await this.find(options)
      return docs
    },

    async getMany (ids = []) {
      const { rows } = await this.allDocs({
        include_docs: true,
        keys: ids
      })
      return rows.map(row => row.doc)
    }
  })

  PouchDB.getID = getID

  return PouchDB
}



// WEBPACK FOOTER //
// ../webmango-db/db.js